module.exports = __webpack_public_path__ + "img/button_home.08754349.svg";